import { ForgeProjectContext } from "./SDKForgeProjectContext";
import { ForgeProjectInvitation } from "./SDKForgeProjectInvitation";
import { ForgeProjectMembership } from "./SDKForgeProjectMembership";
export class ForgeProject {
    constructor(model) {
        var _a;
        this.createdAt = new Date(model.createdAt);
        this.createdByUserId = model.createdByUserId;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : undefined;
        this.id = model.id;
        this.instruction = model.instruction;
        this.meta = model.meta;
        this.name = model.name;
        this.context = new ForgeProjectContext(model.context);
        this.tags = model.tags;
        this.members = model.members.map((member) => new ForgeProjectMembership(member));
        this.workspaceId = model.workspaceId;
        this.accessMode = model.accessMode;
        this.isArchived = (_a = model.isArchived) !== null && _a !== void 0 ? _a : false;
        this.invitations = model.invitations.map((invitation) => new ForgeProjectInvitation(invitation));
        this.emoji = model.emoji;
    }
    toRemote() {
        var _a;
        return Object.assign(Object.assign({}, this), { context: this.context.toRemote(), members: this.members.map((member) => member.toRemote()), invitations: this.invitations.map((invitation) => invitation.toRemote()), createdAt: this.createdAt.toISOString(), updatedAt: (_a = this.updatedAt) === null || _a === void 0 ? void 0 : _a.toISOString() });
    }
}
